import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Box, Button, Stack, Typography } from "@mui/material";
import SyntaxHighlighter from "react-syntax-highlighter";

import LayerdIcon from "../../../../common/LayerdIcon";
import { DETECTION_ICONS } from "../../../../../icons/detectionLucideIcons";
import { secondaryButtonStyle } from "../wafEventDrawerShared";
import {
  spMonoFontFamily,
  spJsonHighlightStyle,
  spRawJsonViewerBodySx,
  spRawJsonViewerFilenameSx,
  spRawJsonViewerHeaderSx,
  spRawJsonViewerShellSx,
  spLh,
} from "./smartParseDrawerUi";

const TRAFFIC_LIGHT_COLORS = ["#FF5F57", "#FFBD2E", "#28CA42"];

function TrafficLights() {
  return (
    <Stack direction="row" spacing={0.75} sx={{ flexShrink: 0 }}>
      {TRAFFIC_LIGHT_COLORS.map((color) => (
        <Box
          key={color}
          sx={{
            width: 8,
            height: 8,
            borderRadius: "50%",
            backgroundColor: color,
          }}
        />
      ))}
    </Stack>
  );
}

export default function SmartParseRawJsonViewer({
  data,
  onCopy,
  filename = "smart_parse_event.json",
}) {
  const jsonString = useMemo(() => JSON.stringify(data, null, 2), [data]);

  return (
    <Box sx={spRawJsonViewerShellSx}>
      <Box sx={spRawJsonViewerHeaderSx}>
        <Stack direction="row" alignItems="center" spacing={1.25} sx={{ minWidth: 0, flex: 1 }}>
          <TrafficLights />
          <Typography sx={spRawJsonViewerFilenameSx} noWrap>
            {filename}
          </Typography>
        </Stack>
        <Button
          variant="outlined"
          size="small"
          startIcon={<LayerdIcon icon={DETECTION_ICONS.copy} size={14} color="primary" />}
          onClick={() => onCopy?.(jsonString)}
          sx={{ ...secondaryButtonStyle, flexShrink: 0, height: 32, px: 1.5 }}
        >
          Copy JSON
        </Button>
      </Box>
      <Box sx={spRawJsonViewerBodySx}>
        <SyntaxHighlighter
          language="json"
          style={spJsonHighlightStyle}
          customStyle={{
            background: "transparent",
            padding: 0,
            margin: 0,
            fontSize: 12,
            lineHeight: spLh.body,
            fontFamily: spMonoFontFamily,
          }}
        >
          {jsonString}
        </SyntaxHighlighter>
      </Box>
    </Box>
  );
}

SmartParseRawJsonViewer.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  onCopy: PropTypes.func,
  filename: PropTypes.string,
};
